import { Component, effect, inject, input, signal } from '@angular/core';
import { PanelModule } from 'primeng/panel';
import { TableModule } from 'primeng/table';
import { IIo } from '../../../../models/io';
import { Functions } from '../../../../services/shared/functions';
import { IconsStyles } from '../../../../services/shared/icons-styles';

@Component({
  selector: 'app-d-outputs-table',
  imports: [TableModule, PanelModule],
  templateUrl: './d-outputs-table.html',
  styleUrl: './d-outputs-table.css',
})
export class DOutputsTable {
  ioInformation = input.required<IIo>();
  isLoading = input.required<boolean>();
  readonly iconsStyles = inject(IconsStyles);
  readonly customFunctions = inject(Functions);
  readonly shouldBeCollapsed = this.customFunctions.shouldBeCollapsed();

  tableRows = signal<string[]>([]);
  headersSmall = signal<string[]>([]);
  outputValues = signal<boolean[]>([]);
  controllableValues = signal<boolean[]>([]);

  tableRowsSmall = signal<{ controllable: boolean; value: boolean }[]>([]);

  constructor() {
    this.tableRows.set(['Controllable', 'Status']);
    this.headersSmall.set(['Status', 'Controllable']);

    effect(() => {
      const io = this.ioInformation();

      if (!io) {
        return;
      }

      this.outputValues.set([]);
      this.controllableValues.set([]);
      this.tableRowsSmall.set([]);

      for (let i = 0; i < io.amountOfOutputs; i++) {
        let outputValue = this.customFunctions.bitwiseIO(
          io.digitalOutputs,
          i + 1
        );
        let controllableValue = this.customFunctions.bitwiseIO(
          io.controllableOutputs,
          i + 1
        );

        this.outputValues.update((values) => {
          return [...values, outputValue];
        });
        this.controllableValues.update((values) => {
          return [...values, controllableValue];
        });
        this.tableRowsSmall.update((values) => {
          return [
            ...values,
            {
              controllable: controllableValue,
              value: outputValue,
            },
          ];
        });
      }
    });
  }
}
